import api from "@/lib/api";

// Data-driven: find the nearest OPEN branch. Uses postcode + distance when available,
// otherwise falls back to the first open branch. Works for any number of branches with
// no per-branch setup (all branches come from the public/for-postcode endpoints).
export async function findNearestOpenBranch({ postcode, excludeId } = {}) {
  try {
    if (postcode) {
      const { data } = await api.get(`/branch/for-postcode?postcode=${encodeURIComponent(postcode)}`);
      const open = (data.branches || [])
        .filter((b) => b.is_open && b.id !== excludeId)
        .sort((a, b) => ((b.delivers ? 1 : 0) - (a.delivers ? 1 : 0)) || ((a.distance ?? 9999) - (b.distance ?? 9999)));
      if (open.length) return open[0];
    }
    const { data } = await api.get("/branch/public");
    const open = (data || []).filter((b) => b.is_open && b.id !== excludeId);
    return open[0] || null;
  } catch {
    return null;
  }
}
